import React from 'react';
import PropTypes from 'prop-types';
import Form from 'components/react-validation/components/form';
import emptyImages from 'assets/img/empty-images.svg';
import { isEmpty } from 'lodash';
import Linkify from 'react-linkify';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import { connect } from 'react-redux';
import * as LotActionType from '../../constants';
import { withRouter } from 'react-router-dom';
import exitIcon from 'assets/img/exit.svg';

class ViewInventory extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    breadcrumbs: PropTypes.any,
    categoryId: PropTypes.string,
    categoryProfile: PropTypes.object,
    builderProfile: PropTypes.object,
    history: PropTypes.object,
    onViewItem: PropTypes.func
  }
  constructor(props) {
    super(props);

    this.state = {
      imagePreview: null
    };
  }

  componentDidMount() {
    if (this.props.categoryId) {
      this.onGetCategoryProfile({
        id: this.props.categoryId
      });
    }
  }

  onGetCategoryProfile = (params, callback) => {
    this.props.dispatch({
      type: LotActionType.GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_ASYNC,
      params: {
        id: params.id,
        builderHost: this.props.builderProfile.builderHost,
        headers: {
          key: this.props.builderProfile.headerKey,
          value: this.props.builderProfile.securityToken
        }
      },
      callback
    });
  }

  onTogglePreviewImages = (url) => {
    this.setState({
      imagePreview: url
    });
  }

  renderCategoryValue = value => {
    if (value) {
      return <Linkify><strong style={{ wordBreak: 'break-word' }}>{value}</strong></Linkify>;
    }
    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  onCustomAction = () => {
    this.props.onFetchListCategory();
  }

  render() {
    const { note, name, images } = this.props.categoryProfile;
    const { imagePreview } = this.state;
    const breadcrumbs = [
      { title: 'Inventory', url: '/', onCustomAction: () => this.props.goBack() },
      { title: `${name}`, url: '' }
    ];

    return (
      <React.Fragment>
        <div className='container-fluid'>
          <h4 style={{ height: 30, marginTop: -15, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {name}
          </h4>
          <Form ref={c => { this.form = c; }}>
            <div className='breadcumb-category'>
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>
            <div className='add-new-category-item row'>
              <div className='col-md-6 col-sm-6 col-xs-12'>
                <div className='view-details'>
                  <div className='row col-sm-12'>
                    <label className='col-sm-3 col-xs-12 font-normal control-label'>Name</label>
                    {
                      <div className='col-sm-9 control-label name form-text-label'>
                        {this.renderCategoryValue(name ? name : null)}
                      </div>
                    }
                  </div>
                </div>
                <div className='view-details'>
                  <div className='row col-sm-12'>
                    <label className='col-sm-3 col-xs-12 font-normal control-label'>Notes</label>
                    {
                      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
                        className='col-sm-9 control-label note form-text-label'>
                        {this.renderCategoryValue(note ? note : null)}
                      </div>
                    }
                  </div>
                </div>
                <div className='view-details'>
                  <div className='row col-sm-12' style={{paddingLeft: '27px', paddingTop: '20px'}}>
                    <div style={{display: 'inline-block', cursor: 'pointer'}} onClick={this.props.onViewItem} >
                      <img src={exitIcon} width={24} height={24} />
                      <span> View all associated items</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='image-category col-md-6 col-sm-6 col-xs-12'>
                <div className='preview-category-image'>
                  <div className='container-fluid'>
                    <div className='row'>
                      <div className='col-md-12 col-xs-12'>
                        {!imagePreview && <img
                          className='empty-category-image'
                          src={images && images[0] ? images[0].url : emptyImages}
                          alt='no-files'
                        />}
                        {
                          imagePreview &&
                          <img className='empty-category-image' src={imagePreview && !isEmpty(images) ? imagePreview : emptyImages} alt='no-files' />
                        }
                      </div>
                    </div>
                  </div>
                  <div className='list-thumbnail-image-after-upload'>
                    <div className='row'>
                      <div style={{ display: 'flex', justifyContent: 'center' }} className='col-md-12 col-xs-6'>
                        <div className='container-fluid'>
                          {
                            !isEmpty(images) && (
                              images.map((el, index) => {
                                return (
                                  <div key={index} className='image-file-after-upload col-md-2 col-xs-2 col-lg-2'>
                                    <img className='category-img-item' onClick={() => this.onTogglePreviewImages(el.url)} src={el.url} />
                                  </div>
                                );
                              }))
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='thumbnail-image-add-success' />
              </div>
            </div>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categoryProfile: state.LotStore.CategoryProfile || {}
  };
};

export default withRouter(connect(mapStateToProps)(ViewInventory));



// WEBPACK FOOTER //
// ./src/Lots/Components/Inventory/inventory-view.js